import React from 'react';
import gruns_img from '../assets/gruns_img.png';

const HeroSection = () => {
    return (
        <section className="bg-[#dfefe7]">
            {/* <section className="bg-gradient-to-r from-gruns-gradient-start via-gruns-gradient-mid to-gruns-gradient-end text-white"> */}
            <div className="max-w-[1200px] mx-auto py-[60px] md:py-[90px] px-4 md:px-0">
                <div className="flex flex-col-reverse md:grid md:grid-cols-2 gap-8 md:gap-12 items-center">
                    {/* Left Column - Text Content */}
                    <div className="space-y-6 text-left">
                        <h1 className="text-[28px] md:text-[43px] font-semibold text-black leading-[1.4] md:leading-[1.2] md:leading-[50px] tracking-wider md:tracking-normal">
                            Your Exclusive Offer – <span className="text-gruns-green">Save up to 40% OFF on Auto-Ship<span className="text-black">!</span></span>
                        </h1>
                        <p className="text-[15px] md:text-[20px] text-black leading-[1.5] md:leading-[30px]">  
                            Lock in your 15% auto-ship discount and stack additional volume savings up to 40% OFF! Never run out of the perfect social experience <span className="text-black font-semibold">– delivered effortlessly to your door.</span>
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-start">
                            <div className="relative w-fit">
                                <div className="absolute top-[5px] md:top-[7px] left-[5px] w-full h-full bg-[#000] rounded-full"></div>
                                <button className="relative bg-[#008037] border border-[#000] text-white font-semibold py-3 md:py-4 px-8 rounded-full hover:translate-y-[1px] hover:translate-x-[1px] transition-transform duration-200 text-sm tracking-[2px]">
                                    Get Offer Today
                                </button>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4 text-sm hidden">
                            <div className="flex items-center">
                                <span className="text-yellow-300">★★★★★</span>
                                <span className="ml-2">4.8 stars</span>
                            </div>
                            <span>|</span>
                            <span>250,000+ members</span>
                        </div>
                    </div>

                    {/* Right Column - Image */}
                    <div className="relative md:mb-0">
                        <img
                            src="https://cdn.shopify.com/s/files/1/0022/3821/8300/files/SuperBasic-GirlTalk-12.jpg?v=1732429922"
                            className="w-full h-auto rounded-[20px]"
                            alt="Grüns product"
                        />
                        {/* <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-lg shadow-lg">
                            <div className="text-center">
                                <p className="text-gruns-green font-bold">Ships within 24 Hours</p>
                                <p className="text-sm text-gray-600">Mon-Fri</p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
